module.exports = __webpack_public_path__ + "img/bordado_negro.bf0c4948.jpg";